<template>
  <div class="container">
    <div class="card-block-box">
      <div
        class="card-block-flex"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <pi-card-block
          className="pd30"
          :item="item"
          @click="cardClick"
        ></pi-card-block>
      </div>
    </div>
  </div>
</template>
<script>
import cardBlock from "@/components/pi-card-block/pi-card-block.vue";
import {getOperInfo} from '@/common/api'
export default {
  name: "service-center",
  data() {
    return {
      cardList: [
        {
          name: "意见反馈",
          icon: require("../../picture/my/server-feedback.png"),
          url: "/feedback",
        },
        {
          name: "业务咨询",
          icon: require("../../picture/my/server-business.png"),
          url: "/business-consulting",
        },
        {
          name: "常见问题",
          icon: require("../../picture/my/server-problem.png"),
          url: "/common-problem",
        },
        {
          name: "客服电话",
          icon: require("../../picture/my/server-tel.png"),
          type: "tel",
        },
      ],
    };
  },
  components: {
    [cardBlock.name]: cardBlock,
  },
  methods: {
    cardClick(item) {
      if (item.type == "tel") {
        let tel = this.operInfo.serviceTel
          ? this.operInfo.serviceTel
          : this.operInfo.tel;

        window.location.href = "tel:" + tel;
      } else {
        this.$router.push(item.url);
      }
    },
    /**
     * 获取运营商信息
     */
    async getOperInfo() {
      let ret = await getOperInfo(
        {
          oprPkId: this.$route.query.oprPkId,
        },
        { loading: false }
      );
      if (ret.status === 0 && ret.data) {
        let data = ret.data[0] || {};
        this.operInfo = data;
      }
    },
  },
  mounted() {
    this.getOperInfo();
  },
};
</script>
<style lang="less" scoped>
.container{
  padding: 0.20rem;
}
.card-block-box{
  background: #FFFFFF;
  box-shadow: 0px 0px 0.10rem 0px #EFEFF4;
  border-radius: 0.16rem;
  display: flex;
}
.card-block-flex{
  width: 25%;
}
</style>